/* eslint-disable */
// export const ENTRYPOINT = getBaseUrl()
// export const ENTRYPOINT = 'http://zgloszenia.arcop.pl/core/public/index.php/api/'
// export const ENTRYPOINT = 'https://drogbruktest.excm.pl/core/public/index.php/api/'
// export const ENTRYPOINT = 'https://drogbruk.excm.pl/core/public/index.php/api/'
// export const ENTRYPOINT = 'https://drogbruk.edusky.pl/core/public/index.php/api/'
// export const ENTRYPOINT = 'https://poxbox.excm.pl/core/public/index.php/api/'
export const ENTRYPOINT = 'https://iam.edusky.pl/core/public/index.php/api/'
// export const ENTRYPOINT = 'https://so.edusky.pl/core/public/index.php/api/'
// export const ENTRYPOINT = 'http://test.arcop.pl/core/public/index.php/api/'
// export const ENTRYPOINT = 'https://kolnet.excm.pl/core/public/index.php/api/'
// export const ENTRYPOINT = 'http://localhost/skyOfficeSymfony/public/index.php/api/'
